import * as fromSchoolSearchResults from '../actions/school-searchresults.action';
import * as fromModels from '../../models';
import { HttpHeaders } from '@angular/common/http';

export interface SearchResultsState {
    searchResults: fromModels.SchoolSearchResultsItem[];
    searchCriteria: fromModels.SchoolSearchCriteria;
    pagingSorting: fromModels.SchoolPagingSorting;
    errors: any;	//	TODO: formalize error handling
    loading: boolean;
    loaded: boolean;
}

export const initialState: SearchResultsState = {
    loading: false,
    loaded: false,
    searchResults: null,
    errors: null,
    searchCriteria: {
        callDay: null,
        code: null,
        county: null,
        districtId: null,
        districtName: null,
        gradeLevel: null,
        id: null,
        isActive: null,
        longName: null,
        offersBandshare: null,
        PageNumber: null,
        PageSize: null,
        phone: null,
        primaryFulfillmentSite: null,
        radius: null,
        schoolType: null,
        SortBy: null,
        SortDir: null,
        state: null,
        teacherId: null,
        zip: null,
    },
    pagingSorting: {
        totalCount: null,
        pageSize: null,
        currentPage: null,
        totalPages: null,
        sortBy: null,
        sortDir: null
    }
};

export function reducer(state = initialState, action: fromSchoolSearchResults.SchoolSearchResultsActions): SearchResultsState {
    switch (action.type) {
        case fromSchoolSearchResults.SchoolSearchResultsActionTypes.ProcessQueryString: {
            console.log('ProcessQueryString');
            console.log(action.payload);

            return {
                ...state,
                loaded: false,
                loading: false,
                errors: null
            };
        }

        case fromSchoolSearchResults.SchoolSearchResultsActionTypes.LoadSchoolSearchResults: {
            console.log('LoadSchoolSearchResults');
            console.log(action.payload);
			return {
                ...state,
                loaded: false,
                loading: true,
                errors: null,
                // Anytime we request search results, let's update the state to include that
                // most recent criteria that was just passed.
                searchCriteria: action.payload
			};
		}

        case fromSchoolSearchResults.SchoolSearchResultsActionTypes.LoadSchoolSearchResultsSuccess: {
            const searchResults = action.payload;
            const headers = action.httpHeaders;

			return {
                ...updateSchoolSearchResultsState(state, searchResults, headers),
				loaded: true,
                loading: false
			};
		}

        case fromSchoolSearchResults.SchoolSearchResultsActionTypes.LoadSchoolSearchResultsFailure: {
			console.log('reducer:', action);

			return {
				...state,
				loaded: false,
				loading: false,
                errors: action.payload
			};
        }
	}

	return state;
}

function updateSchoolSearchResultsState(state: SearchResultsState, searchResults: fromModels.SchoolSearchResultsItem[], headers: HttpHeaders) {
    let pagingSorting: fromModels.SchoolPagingSorting;

    // Grab special header we use for paging
    const pagingHeader: string = headers.get('X-Pagination');
    const pagingObject: object = JSON.parse(pagingHeader);

    // Populate paging information from http headers
    pagingSorting = {
        totalCount: pagingObject['totalCount'],
        pageSize: pagingObject['pageSize'],
        currentPage: pagingObject['currentPage'],
        totalPages: pagingObject['totalPages'],
        sortBy: pagingObject['sortBy'],
        sortDir: pagingObject['sortDir']
    };

	return {
		...state,
        searchResults,
        pagingSorting
	};
}

export const getSchoolSearchResults = (state: SearchResultsState) => state.searchResults;
export const getSchoolSearchLoading = (state: SearchResultsState) => state.loading;
export const getSchoolSearchLoaded = (state: SearchResultsState) => state.loaded;
export const getSchoolSearchErrors = (state: SearchResultsState) => state.errors;
